import { Locale } from '~l10n/types';

export const SUPPORTED_LANGUAGES: ReadonlyArray<{
  code: Locale;
  language: string;
}> = [
  { code: 'en', language: 'English' },
  { code: 'cy', language: 'Cymraeg' },
  { code: 'da', language: 'Dansk' },
  { code: 'de', language: 'Deutsche' },
  { code: 'es', language: 'Español' },
  { code: 'fi', language: 'Suomi' },
  { code: 'fr', language: 'Français' },
  { code: 'it', language: 'Italiano' },
  { code: 'ko', language: '한국어' },
  { code: 'nb', language: 'Norvégien (Bokmål)' },
  { code: 'nl', language: 'Nederlands' },
  { code: 'pl', language: 'Polski' },
  { code: 'pt-BR', language: 'Português (Brasil)' },
  { code: 'pt-PT', language: 'Português (Portugal)' },
  { code: 'sv', language: 'Svenska' },
  { code: 'th', language: 'ไทย' },
  { code: 'tr', language: 'Türk' },
  { code: 'zh-CN', language: '简体中文' },
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number]['language'];
export type SupportedLanguageCode = typeof SUPPORTED_LANGUAGES[number]['code'];
